<div class="stepper-container">
  @for (step of steps; track step.value; let i = $index) {
    <div
      class="step"
      [class.first]="i === 0"
      [class.last]="i === steps.length - 1"
      [class.middle]="i > 0 && i < steps.length - 1"
      [class.active]="isActive(step)"
      [class.completed]="isCompleted(step)"
      [class.default]="!isActive(step) && !isCompleted(step)"
    >
      <span class="step-label">
        {{ step.label }}
      </span>
    </div>
  }
</div>
